import React, {useState, useEffect} from "react";
// import {useState, useEffect} from "react";
import "./index.css";
import Navbar from "./Navbar";
// import videoSrc from './videos/section-2-video-TG.mp4';
import videoSrc from './videos/Video-Eleven-Fit-Site-2-TG.mp4';
import ProgramImage from './images/program-static-11-fit-TG.png';
import ReactPlayer from "react-player/youtube";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom"
import ScrollToSection from "./ScrollToSection";
import HomePage from "./HomePage"; // Import the HomePage component
import Contact from "./Contact";
import Store from "./Store";
import ProductManager from "./ProductManager";
import Workouts from "./Workouts";
import Program from "./Program";
import Checkout from "./Checkout";
import PaymentComplete from "./PaymentComplete";
import CartDisplay from "./CartDisplay";
import AboutMe from "./AboutMe";
import Functional from "./Functional";
import BankTransfer from "./BankTransfer";
import BankApprovals from "./BankApprovals";
import AddToCart from "./AddToCart"; // #added link directo de compra 21/8/26 TG
import Analytics from "./Analytics"; // #added dashboard de visitas 20/9/26 TG
import AnalyticsTracker from "./useAnalytics"; // #added tracker de visitas 20/9/26 TG
import MetaPixelTracker from "./metaPixel"; // #added Meta Pixel 2/11/26 TG
import Privacy from "./Privacy"; // #added 3/11/26 TG
import SiteFooter from "./SiteFooter"; // #added 3/11/26 TG

function App() {
  return (
    <Router>
      <AnalyticsTracker />{/* #added manda un pageview en cada cambio de ruta 20/9/26 TG */}
      <MetaPixelTracker />{/* #added 2/11/26 TG */}
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/workouts" element={<Workouts />} />
        <Route path="/program/:planId?" element={<Program />} />
        <Route path="/store" element={<Store />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/payment-complete" element={<PaymentComplete />} />
        <Route path="/product-manager" element={<ProductManager />} />
        <Route path="/cart" element={<CartDisplay />} />
        {/* #added links directos de compra desde la app de workouts 21/8/26 TG */}
        <Route path="/add/:planId" element={<AddToCart />} />
        <Route path="/cart/add/:planId" element={<AddToCart />} />
        <Route path="/add" element={<AddToCart />} />
        <Route path="/about" element={<AboutMe />} />
        <Route path="/functional" element={<Functional />} />
        <Route path="/bank-transfer" element={<BankTransfer />} />
        <Route path="/admin/bank-approvals" element={<BankApprovals />} />
        <Route path="/admin/analytics" element={<Analytics />} />{/* #added 20/9/26 TG */}
        <Route path="/privacy" element={<Privacy />} />{/* #added 3/11/26 TG */}
      </Routes>
      <SiteFooter />
    </Router>
  );
}

export default App;
